import { NavigationSite } from "../../layout/navigation/navigationSite";

export class TvScheduleNavigationDropdown {
    ESC_keyCode = 27;

    // staff
    win = $(window);
    dropdown;

    constructor() {
        this.init();
    }

    init() {
        this.dropdown = $('.navigation-dropdown');
        if (!this.dropdown.length) {
            return;
        }

        this.bindEvents();

        // Navegación para "colorear" la cadena seleccionada
        new NavigationSite('.navigation-dropdown-tv-schedule');
        new NavigationSite('.tv-schedule__channels__desktop-icon-menu');
    }

    bindEvents() {
        this.win.on('keyup', (e) => this.onESCKeyup(e));
        this.dropdown.on('click', 'a[id^="navigation-dropdown__selector"]', (e) => this.toggleDropdown(e));
    }

    toggleDropdown(e) {
        e.preventDefault();
        const ul = $(e.currentTarget)[0];
        $(ul).toggleClass('drop-down-arrow--active');
    }

    onESCKeyup(e) {
        e.preventDefault();

        if (e.keyCode !== this.ESC_keyCode) {
            return;
        }

        this.closeDropdown();
    }

    // auxiliary
    closeDropdown() {
        this.dropdown.find('#navigation-dropdown__selector').removeClass('drop-down-arrow--active')
    }
}
